// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__lUmjU","modal":"modal_modal__NuJqK","content":"modal_content__3vkSz","logo":"modal_logo__cop26"};